<template>
  <v-container
    id="lista_fatture"
    v-touch="{
      left: () => swipe('Left'),
      right: () => swipe('Right'),
    }"
    fluid
    tag="section"
    style="height: calc(100% - 110px)"
  >
    <base-material-card
      icon="mdi-eye-refresh"
      class="px-5 py-3"
      width="100%"
      title="Lista Fatture"
    >
      <v-row class="mt-4">
        <v-col
          cols="12"
        >
          <table
            v-if="cliente"
            class="text-h4 text-weigth-light"
          >
            <tr>
              <td class="text-no-wrap pr-3">
                Cliente
                <div v-if="isMobile">
                  {{ cliente.ragsoc }} {{ cliente.indiri_1 }}<br>
                  {{ cliente.indiri2 }} {{ cliente.locali }}
                </div>
              </td>
              <td v-if="!isMobile">
                {{ cliente.ragsoc }} {{ cliente.indiri_1 }}
              </td>
            </tr>
            <tr v-if="!isMobile">
              <td /><td>{{ cliente.indiri2 }} {{ cliente.locali }} </td>
            </tr>
          </table>
        </v-col>
      </v-row>
      <v-row
        no-gutters
        class="mt-6 justify-space-between"
      >
        <p class="text-h4 text-weigth-light">
          Periodo:
        </p>

        <v-menu
          v-model="mnu_data_start"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="$formatDate(data_start).substring(0, 10)"
              label="Data Inizio"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="data_start"
            locale="it-IT"
            @input="mnu_data_start = false"
          />
        </v-menu>
        <v-menu
          v-model="mnu_data_end"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="$formatDate(data_end).substring(0, 10)"
              label="Data Fine"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="data_end"
            :allowed-dates="(val) => val >= data_start"
            locale="it-IT"
            @input="mnu_data_end = false"
          />
        </v-menu>
        <v-btn
          color="primary"
          @click="get_listaFatture"
        >
          <v-icon>mdi-magnify</v-icon>
          Cerca
        </v-btn>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            v-if="listOrders"
            loading-text="Caricamento..."
            :loading="loading"
            :search="search"
            :items-per-page="-1"
            hide-default-footer
            :headers="headers"
            :items="listOrders"
            class="elevation-1"
          >
            <template v-slot:item.TFTF_TIPDOC="{item}">
              {{ tipodoc[item.TFTF_TIPDOC] }}
            </template>
            <template v-slot:item.TFTF_NUMFAT="{item}">
              {{ parseInt(item.TFTF_NUMFAT.substring(4)) }}
            </template>
            <template v-slot:item.actions="{item}">
              <v-btn
                text
                @click="sendDupRequest(item)"
              >
                <v-icon
                  large
                  color="red"
                >
                  mdi-content-duplicate
                </v-icon> Richiedi Duplicato
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </base-material-card>

    <v-overlay :value="loading">
      <v-row
        style="width:50vw; position:fixed; left:30vw"
      >
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-row>
    </v-overlay>
  </v-container>
</template>

<script>
  import Config from '@/config.js'

  import { mapState } from 'vuex'
  import engine from '@/plugins/engine'

  export default {
    name: 'ListaFatture',
    components: {

    },
    data () {
      return {
        loading: false,
        cliente: null,
        codcli: null,
        search: null,
        valid: true,
        listOrders: false,
        showBackOnline: false,
        mnu_data_start: false,
        data_start: new Date((Date.now() - (new Date()).getTimezoneOffset() * 60000) - (90 * 24 * 60 * 60 * 1000)).toISOString().substring(0, 10),
        mnu_data_end: false,
        data_end: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
        tipodoc: { 1: 'FT', 2: 'ND', 3: 'NC', 6: 'FT', 7: 'ND', 8: 'NC' },

        headers: [
          { text: 'Anno', value: 'TFTF_ANNFAT' },
          { text: 'Tipo', value: 'TFTF_TIPDOC' },
          { text: 'Numero', value: 'TFTF_NUMFAT' },
          { text: 'Data', value: 'TFTF_DATDOC' },
          { text: 'Totale', value: 'TFTF_TOTFAT', align: 'right' },
          { text: '', value: 'actions', align: 'right' },
        ],
      }
    },
    computed: {
      ...mapState(['auth', 'clidata']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },
      config () {
        return Config
      },
    },
    watch: {
      onLine (v) {
        if (v) {
          this.showBackOnline = true
          setTimeout(() => {
            this.showBackOnline = false
          }, 1000)
        }
      },
    },
    mounted () {
      window.addEventListener('online', this.updateOnlineStatus)
      window.addEventListener('offline', this.updateOnlineStatus)
      this.cliente = this.clidata.anacli
      var codsog = this.auth.userinfo.codsog
      var coddes = this.auth.userinfo.coddes.toString().padStart(3, '0')
      this.codcli = `${codsog}${coddes}`
      console.log('analisi codcli', this.codcli)
      this.get_listaFatture()
    },
    beforeDestroy () {
      window.removeEventListener('online', this.updateOnlineStatus)
      window.removeEventListener('offline', this.updateOnlineStatus)
    },
    methods: {

      swipe (direction) {
        if (direction === 'Left') {
          this.step++
        } else {
          this.step--
        }
      },
      updateOnlineStatus (e) {
        const { type } = e
        this.onLine = type === 'online'
      },
      get_listaFatture () {
        this.loading = true
        engine.get_listaFatture(this.codcli, this.data_start, this.data_end)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
              this.loading = false
              return
            }
            this.listOrders = result.data
          })
          .catch((errore) => {
            console.log('search err: ', errore)
          }).finally(() => { this.loading = false })
      },

      sendDupRequest (item) {
        // var anno = item.TFTF_DATDOC.substring(0, 4)
        // var mese = item.TFTF_DATDOC.substring(5, 7)
        // var giorno = item.TFTF_DATDOC.substring(8, 10)
        // var codsog = this.auth.userinfo.codsog
        // var numfat = item.TFTF_NUMFAT.substring(4)
        // var tipdoc = this.tipodoc[item.TFTF_TIPDOC]

        // var filename = `${codsog}${anno}${mese}${giorno}${tipdoc}_${numfat}.pdf`

        // console.log('download pdf', filename)
      },
    },
  }

</script>
